export default {
    active_requirement_orders: "Faol talab - buyurtmalar",
    add_laboratory_service: "Laboratoriya xizmatini qo'shish",
    after_finished_fixed: "Tugatgandan keyin",
    can_have_dental_work: "Tish ishlarini o'z ichiga olishi mumkin",
    cannot_change_services_that_already_have_laboratory_services_attached: "Siz allaqachon ular bilan bog'langan laboratoriya ishlariga ega xizmatlarni ish buyurtmasidan o'chira olmaysiz.",
    carcass: "Ramka",
    deleted_from_treatment: "Davolashdan olib tashlangan",
    delivery_date: "Yetkazib berish sanasi",
    dental_work: "Tish ishi",
    do_you_confirm_cancel_laboratory_order: "Ishga buyurtmani bekor qilmoqchimisiz?",
    do_you_confirm_laboratory_order_finish: "Ish bemorga topshirilganligini tasdiqlaysizmi? Tasdiqlangandan so'ng shifokorning ish haqi hisoblab chiqiladi va bu ish tartibiga o'zgartirish kiritish mumkin bo'lmaydi.",
    do_you_confirm_laboratory_order_finish2: "Ish bemorga topshirilganligini tasdiqlaysizmi? Tugallangan ish buyurtmasiga o'zgartirish kiritib bo'lmaydi. Tahrirlash uchun siz hujjatni joylashtirishni bekor qilishingiz kerak bo'ladi.",
    executor: "Ijrochi",
    faintly: "Zaif",
    field_is_required: "Maydon to'ldirilishi shart",
    fitting_date: "Moslashma sanasi",
    full: "To'liq",
    immediately: "To'g'ridan-to'g'ri",
    in_clinic: "Klinikada",
    in_lab: "Laboratoriyada",
    initiated: "Boshlang'ich",
    intermediate_part_design: "O'rta dizayn",
    laboratories: "Laboratoriyalar",
    laboratory: "Laboratoriya",
    laboratory_service: "Laboratoriya xizmati",
    LaboratoryOrder: "Ish tartibi",
    logics_on_laboratory_services_deduction: "Laboratoriya ishini ish tartibi bo'yicha ayirish mantiqi",
    moderately: "O'rtacha",
    must_have_dental_work: "Majburiy stomatologik ishlarni o'z ichiga oladi",
    no_dental_work_needed_for_selected_services: "Tanlangan xizmatlar uchun stomatologik ishlar kerak emas",
    no_services: "Xizmatlar yo'q",
    order_number: "Buyurtma raqami",
    paint_restorations: "Restavratsiyalarni bo'yash",
    panorama: "Panorama",
    pay_all: "Hammasini to'lash",
    requirement_order: "Talab - buyurtma",
    select_from_price: "Narxdan tanlang",
    send_to_laboratory_via_messenger: "Messenger orqali laboratoriyalarga yuboring",
    shoulder: "Yelka",
    simplified: "Soddalashtirilgan",
    total_orders_for_the_amount: "Miqdoridagi jami buyurtmalar",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "Laboratoriyani o'zgartirganda, tanlangan barcha xizmatlar ro'yxatdan o'chiriladi. Davom etish?",
    without_attachment_to_tooth: "Tishga bog'lanmagan"
}
